import { BooleanField, TextField } from "react-admin";

import Card from "./Card";
import DurationField from "./fields/DurationField";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import ThingField from "./fields/ThingField";
import useIsAdmin from "../useIsAdmin";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const isAdmin = useIsAdmin(props);

  const { "sensor-event-unarmed": highlightedSensorEventUnarmedIds = [] } =
    useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedSensorEventUnarmedIds.includes(id)) return "modifyResource";
    return "";
  };
  return (
    <ResponsiveList
      {...props}
      exporter={false}
      filters={<Filters isAdmin={isAdmin} />}
      type="table"
      split
      key={highlightedSensorEventUnarmedIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        rowBreakpoint="md"
        cardContent={<Card />}
        target="sensor-event-unarmed"
        rowClasses={rowClass}
      >
        <TextField source="id" />
        {isAdmin && <TextField source="user.username" sortBy="user.username" />}
        <ThingField source="location.tree_name" sortBy="location.tree_name" />
        <ThingField source="device.name" sortBy="device.name" />
        <ThingField source="sensor.name" sortBy="sensor.name" />
        <BooleanField source="is_unarmed" />
        <DurationField source="duration" sortBy="Event.start_at" />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default List;
